import { InjectionToken } from '@angular/core'
import { IAuthServiceConfig } from './auth.interfaces'

export const AUTH_CONFIG = new InjectionToken<IAuthServiceConfig>('app.config.auth')
